var map = {
	"./1.png": "UT82",
	"./1en.png": "qA2I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BpX9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo ^\.\/1.*\.png$
// module id = BpX9
// module chunks = 0